import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { uniqueID } from "../../../firebase/utility";
import { fetchPOsUtil } from "../../../utility";
const usePurchaseOrders = () => {
  const dispatch = useDispatch()
  const history = useHistory();
  const { all_purchase_orders, all_vendors } = useSelector(state => state.orders)
  const { user } = useSelector((state) => state.auth);
  const [page, setPage] = useState(() => {
    const p = parseInt(localStorage.getItem("purchaseOrderPage"), 10);
    return !isNaN(p) ? p : 1;
  });
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(50);
  const [searchValue, setSearchValue] = useState("");
  const [selectedItem, setSelectedItem] = useState("");
  const [selectedData, setSelectedData] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [createOrder, setCreateOrder] = useState(false);
  const [shippingData, setShippingData] = useState(false);
  const [shipping, setShipping] = useState(false);
  const [vendorData, setVendorData] = useState();
  const [selectedOrdersIds, setSelectedOrdersIds] = useState([]);
  const handleShippingData = (data) => {
    let id = uniqueID();
    let vendor = vendorData;
    let shipping = {
      address_1: "206 Far Hill Drive",
      address_2: "",
      city: "Bolingbrook",
      company: "TechMicro USA INC",
      state: "IL",
      terms: "Due on Receipt",
      first_name: "Receiving",
      last_name: "Department",
      country: "US",
      postcode: "60440",
      email: "purchasing@techmicrousa.com",
      creditLimit: false,
      notes: [],
      phone: "16305261800",
    };
    history.push({
      pathname: `/admin/purchase-orders-details/${id}`,
      state: {
        obj: { shipping: shipping },
        vendor,
        new: true,
        directPO: true,
        tagSaleOrders: selectedOrdersIds,
      },
    });
  };
  const gettingPos = () => {
    fetchPOsUtil({
      page,
      search: searchValue,
      pageSize,
      selectedItem,
      setLoading,
      dispatch,
      setTotalPages,
    });
  }
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      gettingPos()
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [page, searchValue, selectedItem, pageSize]);
  useEffect(() => {
    let search = localStorage.getItem('purchaseSearch')
    setSearchValue(search)
  }, [])
  useEffect(() => {
    setPurchaseOrders(all_purchase_orders ?? [])
  }, [all_purchase_orders])
  return {
    purchaseOrders,
    searchValue,
    setSearchValue,
    selectedItem,
    setSelectedItem,
    selectedData,
    setSelectedData,
    selectedRows,
    setSelectedRows,
    user,
    createOrder,
    setCreateOrder,
    shippingData,
    setShippingData,
    page,
    setPage,
    pageSize,
    setPageSize,
    loading,
    totalPages,
    purchaseOrders,
    history,
    setShippingData,
    vendorData,
    setVendorData,
    selectedOrdersIds,
    setSelectedOrdersIds,
    handleShippingData,
    shipping, setShipping,
    all_vendors, gettingPos
  };
};
export default usePurchaseOrders;
